import React from 'react';

const Input = ({
  label,
  dark,
  white,
  maxWidth,
  placeHolderIs,
  marginRight,
  ...rest
}) => {
  return (
    <div className="flex flex-col flex-grow">
      <p
        className={`${
          dark ? 'text-white' : 'text-black'
        } text-xs uppercase font-light`}>
        {label}
      </p>
      <input
        {...rest}
        placeholder={placeHolderIs}
        className={`${
          dark ? 'bg-trueGray-100' : 'bg-transparent'
        } rounded h-8 my-2 px-2 text-sm ${dark ? 'border-0' : 'border'}`}
        style={{
          backgroundColor: white ? 'white' : 'transparent',
          maxWidth: maxWidth ? maxWidth : undefined,
          marginRight: marginRight,
        }}
      />
    </div>
  );
};

export default Input;
